var _defs, _path, _path2, _path3, _path4, _rect, _path5, _path6, _g, _g2, _path7, _rect2, _path8, _path9, _path10, _path11, _g3, _g4, _path12, _rect3, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinishProfileMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97.181,
    height: 90.84,
    viewBox: "0 0 97.181 90.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10816",
    "data-name": "Path 10816",
    d: "M0,0H97.181V90.84H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1767",
    "data-name": "Rectangle 1767",
    width: 35.149,
    height: 0.937
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1769",
    "data-name": "Rectangle 1769",
    width: 16.034,
    height: 1.848
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1773",
    "data-name": "Rectangle 1773",
    width: 20.489,
    height: 2.782,
    fill: "#699dee"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1774",
    "data-name": "Rectangle 1774",
    width: 14.01,
    height: 1.224,
    fill: "#699dee"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1777",
    "data-name": "Rectangle 1777",
    width: 68.037,
    height: 40.675,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12644",
    "data-name": "Group 12644",
    transform: "translate(-638.476 -435.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9718",
    "data-name": "Group 9718",
    transform: "translate(638.476 435.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9716",
    "data-name": "Group 9716",
    transform: "translate(0 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10823",
    "data-name": "Path 10823",
    d: "M80.064,347.706c0,1.707-17.923,3.09-40.032,3.09S0,349.413,0,347.706s17.923-3.09,40.032-3.09,40.032,1.384,40.032,3.09",
    transform: "translate(8.559 -259.956)",
    fill: "#7586ec",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9714",
    "data-name": "Group 9714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9713",
    "data-name": "Group 9713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9711",
    "data-name": "Group 9711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_26",
    "data-name": "Mask Group 26",
    clipPath: "url(#clip-path)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10786",
    "data-name": "Path 10786",
    d: "M2265.326,938.087h-3.333a.612.612,0,1,1,0-1.224h3.333a.612.612,0,0,1,0,1.224",
    transform: "translate(-2170.042 -883.426)",
    fill: "#9bc1f9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10787",
    "data-name": "Path 10787",
    d: "M1322.119,0h-6.557a3.4,3.4,0,1,0,0,6.81h6.557a3.4,3.4,0,0,0,0-6.81",
    transform: "translate(-1270.175 0.431)",
    fill: "#1e2849"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10788",
    "data-name": "Path 10788",
    d: "M1097.375,1343.341l-10.02,4.76v1.055h35.687V1348.1l-10.111-4.76Z",
    transform: "translate(-1056.455 -1265.922)",
    fill: "#040227"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1764",
    "data-name": "Rectangle 1764",
    width: 16.041,
    height: 28.339,
    transform: "translate(40.841 49.637)",
    fill: "#040227"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10789",
    "data-name": "Path 10789",
    d: "M601.944,119.157V67.911a2.353,2.353,0,0,0-2.266-2.432h-92.65a2.353,2.353,0,0,0-2.266,2.432v51.246Z",
    transform: "translate(-504.763 -61.033)",
    fill: "#1e2849"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10822",
    "data-name": "Path 10822",
    d: "M0,0H92.045V41.976H0Z",
    transform: "translate(1.771 14.377)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9698",
    "data-name": "Group 9698",
    transform: "translate(31.438 82.297)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9697",
    "data-name": "Group 9697",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9696",
    "data-name": "Group 9696",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1766",
    "data-name": "Rectangle 1766",
    width: 35.149,
    height: 0.937,
    transform: "translate(0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9701",
    "data-name": "Group 9701",
    transform: "translate(40.93 75.571)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9700",
    "data-name": "Group 9700",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9699",
    "data-name": "Group 9699",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1768",
    "data-name": "Rectangle 1768",
    width: 16.034,
    height: 1.848,
    transform: "translate(0)"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10815",
    "data-name": "Path 10815",
    d: "M0,0H22.915V46.247H0Z",
    transform: "translate(72.078 10.106)",
    fill: "#d2e4fd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1771",
    "data-name": "Rectangle 1771",
    width: 93.223,
    height: 4.271,
    transform: "translate(1.77 10.106)",
    fill: "#040227"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10790",
    "data-name": "Path 10790",
    d: "M504.763,1027.006v7.377a2.561,2.561,0,0,0,2.265,2.778h92.65a2.561,2.561,0,0,0,2.266-2.778v-7.377Z",
    transform: "translate(-504.763 -968.882)",
    fill: "#040227"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10791",
    "data-name": "Path 10791",
    d: "M566.293,131.992a.742.742,0,1,1-.742-.742.742.742,0,0,1,.742.742",
    transform: "translate(-561.687 -119.703)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10792",
    "data-name": "Path 10792",
    d: "M616.756,131.992a.742.742,0,1,1-.742-.742.742.742,0,0,1,.742.742",
    transform: "translate(-609.526 -119.703)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10793",
    "data-name": "Path 10793",
    d: "M667.22,131.992a.742.742,0,1,1-.742-.742.742.742,0,0,1,.742.742",
    transform: "translate(-657.366 -119.703)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9704",
    "data-name": "Group 9704",
    transform: "translate(73.278 49.637)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9703",
    "data-name": "Group 9703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9702",
    "data-name": "Group 9702",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10794",
    "data-name": "Path 10794",
    d: "M1933.505,866.57h-18.436a1.028,1.028,0,0,1-1.026-1.026v-.729a1.028,1.028,0,0,1,1.026-1.026h18.436a1.028,1.028,0,0,1,1.026,1.026v.729a1.028,1.028,0,0,1-1.026,1.026m-18.436-2.578a.823.823,0,0,0-.823.822v.729a.824.824,0,0,0,.823.823h18.436a.823.823,0,0,0,.822-.823v-.729a.823.823,0,0,0-.822-.822Z",
    transform: "translate(-1914.043 -863.788)",
    fill: "#699dee"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9707",
    "data-name": "Group 9707",
    transform: "translate(73.38 53.437)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9706",
    "data-name": "Group 9706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9705",
    "data-name": "Group 9705",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10795",
    "data-name": "Path 10795",
    d: "M1929.4,938.087h-12.786a.612.612,0,1,1,0-1.224H1929.4a.612.612,0,1,1,0,1.224",
    transform: "translate(-1916.003 -936.863)",
    fill: "#699dee"
  }))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10796",
    "data-name": "Path 10796",
    d: "M1426.648,18.329a.9.9,0,1,1-.9-.9.9.9,0,0,1,.9.9",
    transform: "translate(-1377.003 -16.094)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1775",
    "data-name": "Rectangle 1775",
    width: 68.037,
    height: 40.675,
    transform: "translate(2.398 14.866)",
    fill: "#d2e4fd"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9710",
    "data-name": "Group 9710",
    transform: "translate(2.063 14.865)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10797",
    "data-name": "Path 10797",
    d: "M901.67,279.039a15.2,15.2,0,0,0-1.872-7.216,6.209,6.209,0,0,0-5.733-2.779c-6.907.451-7.177,9.634-11.339,13.447-1.272,1.165-2.715,2.141-3.909,3.385-4.408,4.6-1.766,12.382,2.793,15.85,3.164,2.406,7.963,3.574,11.514,1.292a11.618,11.618,0,0,0,4.108-5.062,65.3,65.3,0,0,0,2.89-9.08,33.089,33.089,0,0,0,1.548-9.837",
    transform: "translate(-859.288 -265.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10798",
    "data-name": "Path 10798",
    d: "M1019.693,616.935s-6.235.66-7.888,2.4l4.048,21.959s7.69,1.146,12.6-.543c0,0,2.759-17.6.273-21.916-.829-1.438-4.607-1.5-4.607-1.5Z",
    transform: "translate(-987.503 -594.999)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10799",
    "data-name": "Path 10799",
    d: "M1441.869,346.319c-.23-.487-2.28.954-2.734.68s1.836-2.584,1.6-2.987c-.43-.744-2.664,2.375-2.884,2.045s1.926-3.659,1.159-3.842-1.864,3.684-2.257,3.436,1.345-3.5.6-4.169c-.4-.355-2.265,5.941-2.942,6.2s-1.441-2.487-2.079-2.379,2.092,5.056,1.958,5.442-2.633,8.463-4.109,10.9c-.888-.425-1.753-.852-2.578-1.268-.331,1.873-1.1,3.51-1.531,5.349,2.863,1.258,6.146,2.507,6.977,2.2,2.532-.932,3.781-13.223,4.188-15.516s1.489-2.745,2.106-3.951,2.75-1.659,2.52-2.146",
    transform: "translate(-1380.235 -333.855)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10800",
    "data-name": "Path 10800",
    d: "M1245.441,637.867l-3.679,4.411a76.656,76.656,0,0,0,10.024,5.643c.436-1.839,1.509-4.722,1.841-6.6a76.514,76.514,0,0,0-8.185-3.459",
    transform: "translate(-1205.503 -614.843)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10801",
    "data-name": "Path 10801",
    d: "M662.427,344.281c.23-.487,2.28.954,2.734.68s-1.836-2.583-1.6-2.987c.43-.744,2.664,2.375,2.884,2.045s-1.925-3.659-1.159-3.842,1.864,3.684,2.257,3.436-1.345-3.5-.6-4.169c.4-.355,2.265,5.941,2.942,6.2s1.441-2.488,2.079-2.379-2.092,5.056-1.958,5.442,2.633,8.463,4.109,10.9c.888-.425,1.753-.852,2.578-1.268.332,1.873,1.219,3.648,1.655,5.487-2.863,1.258-6.269,2.369-7.1,2.063-2.532-.932-3.781-13.223-4.187-15.516s-1.489-2.745-2.106-3.951-2.75-1.659-2.52-2.146",
    transform: "translate(-656.276 -331.923)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10802",
    "data-name": "Path 10802",
    d: "M931.726,630.479l.666,9.983s-2.568-2.083-7.316,0c-.435-1.839-1.509-4.722-1.841-6.6a63.222,63.222,0,0,1,8.491-3.391",
    transform: "translate(-903.538 -607.839)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10803",
    "data-name": "Path 10803",
    d: "M1146.058,485.136s-.015.14-.043.378a35.667,35.667,0,0,1-1.171,6.012c-.577,1.289,2.607,5.066,5.385,4.394.827-.2-.95-3.6-.9-3.978.095-.72.223-1.7.354-2.71l.219-1.686c.2-1.539.362-2.8.362-2.8Z",
    transform: "translate(-1113.559 -469.689)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10804",
    "data-name": "Path 10804",
    d: "M1164.477,503.015c.028-.238.043-.378.043-.378l4.2-.385s-.162,1.258-.362,2.8c-.07.538-.144,1.111-.218,1.676a3.956,3.956,0,0,1-2.078-.872,5.387,5.387,0,0,1-1.692-2.167c.034-.269.081-.493.1-.67",
    transform: "translate(-1132.14 -486.28)",
    fill: "#ed985f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10805",
    "data-name": "Path 10805",
    d: "M1131.419,306.121a4.038,4.038,0,0,0-3.327,1.688c-1.206,1.791-2.277,7.151,1.191,9.8s6.49-.812,6.742-4.28.16-7.647-4.606-7.2",
    transform: "translate(-1096.646 -300.316)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10806",
    "data-name": "Path 10806",
    d: "M1287.743,409.18c-.34.785-.969,1.249-1.4,1.036s-.511-1.021-.17-1.806.969-1.249,1.4-1.036.511,1.021.17,1.806",
    transform: "translate(-1247.399 -396.285)",
    fill: "#f7a491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10807",
    "data-name": "Path 10807",
    d: "M1097.427,295.368s-2.479,5.2-4.475,5.56-2.083,3.044-2.083,3.044.311-6.18,2.224-7.495a7.427,7.427,0,0,1,4.334-1.11",
    transform: "translate(-1062.456 -290.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10808",
    "data-name": "Path 10808",
    d: "M1104.192,401.7c.223.878-.052,1.716-.614,1.87s-1.2-.432-1.421-1.31.052-1.716.614-1.871,1.2.432,1.421,1.311",
    transform: "translate(-1073.085 -389.688)",
    fill: "#f7a491"
  }))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9715",
    "data-name": "Group 9715",
    transform: "translate(9.855 71.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10819",
    "data-name": "Path 10819",
    d: "M425.856,1058.982a.452.452,0,0,1,.447-.457l5.572-.061h.1l5.572-.061a.452.452,0,0,1,.457.447l.015,1.355-6.078-.315-6.07.448Z",
    transform: "translate(-424.554 -1058.401)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9712",
    "data-name": "Group 9712",
    transform: "translate(0 0.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10817",
    "data-name": "Path 10817",
    d: "M420.7,1141.987h.1l5.6-.061a1.053,1.053,0,0,1,1.063,1.111l-.735,13.36a1.052,1.052,0,0,1-.752.952,22.75,22.75,0,0,1-5.087.464,22.053,22.053,0,0,1-5.029-.353,1.052,1.052,0,0,1-.773-.935l-1.029-13.341a1.054,1.054,0,0,1,1.039-1.134Z",
    transform: "translate(-413.211 -1139.245)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10818",
    "data-name": "Path 10818",
    d: "M397.406,1088.315a1.071,1.071,0,0,1,.928-.9l6.033-.066h.1l6.033-.066a1.071,1.071,0,0,1,.947.883l.508,1.785a.79.79,0,0,1-.751,1.006l-6.7.073h-.1l-6.7.074a.79.79,0,0,1-.773-.989Z",
    transform: "translate(-396.912 -1087.278)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10820",
    "data-name": "Path 10820",
    d: "M422.593,1209.166l-.443,6.074a.245.245,0,0,1-.178.219,24.587,24.587,0,0,1-12.62.139.246.246,0,0,1-.182-.215l-.576-6.063a.246.246,0,0,1,.292-.265,47.975,47.975,0,0,0,13.41-.148.246.246,0,0,1,.3.259",
    transform: "translate(-408.019 -1202.933)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10821",
    "data-name": "Path 10821",
    d: "M512.959,1240.705a2.416,2.416,0,1,0,2.811-1.941,2.415,2.415,0,0,0-2.811,1.941",
    transform: "translate(-507.225 -1231.292)",
    fill: "#f3fdff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishProfileMobile);
export default __webpack_public_path__ + "static/media/finish-profile-mobile.d9565e38b63d29de7cdc2f308078b1c4.svg";
export { ForwardRef as ReactComponent };